<template>
  <div id="summary" class="custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading' && registerForm == null" key="create-loading" />
      <el-row v-else key="content-loading">
        <div class="modal-body">
          <el-collapse v-model="activeName">
            <el-collapse-item class="section" name="1">
              <div class="section-header" slot="title">
                <div class="title">
                  <div class="icon">
                    <i class="fas fa-wallet"></i>
                    <!-- fas fa-credit-card -->
                  </div>
                  <span>{{ $t("summaryComponent.payment-information") }}</span>
                  <i class="fas fa-angle-down"></i>
                </div>
                <div class="actions"></div>
              </div>
              <div class="section-body payment-section">
                <div class="payment-wrapper">
                  <span>{{ $t("summaryComponent.payment-id") }}</span>
                  <span>
                    #
                    <b>{{ paymentInfo.paymentID }}</b>
                  </span>

                  <span>{{ $t("summaryComponent.date") }}</span>
                  <span>
                    <b>{{ $moment(paymentInfo.createDate).format("Do MMM YY") }}</b>
                    ,
                    <b>{{ $moment(paymentInfo.createDate).format("HH:mm") }}</b>
                  </span>

                  <span>{{ $t("summaryComponent.payment-type") }}</span>
                  <span>
                    <b>{{ getEnumsDisplay("PaymentType", paymentInfo.paymentType) }}</b>
                  </span>

                  <span v-if="registerForm.formInfo != null && registerForm.formInfo.title">{{ $t("summaryComponent.registration-form") }}</span>
                  <span v-if="registerForm.formInfo != null && registerForm.formInfo.title">
                    <strong>{{ registerForm.formInfo.title }}</strong>
                  </span>

                  <template v-if="paymentInfo.couponCode != null">
                    <span>{{ $t("summaryComponent.coupon-code") }}</span>
                    <span>
                      <strong>{{ paymentInfo.couponCode }}</strong>
                    </span>
                  </template>

                  <span>{{ $t("summaryComponent.amount") }}</span>
                  <span>
                    <strong>{{ paymentInfo.paidPrice == 0 ? $t("summaryComponent.free") : $currency.format(paymentInfo.paidPrice, { code: getEnumsDisplay("Currency", paymentInfo.currency) }) }}</strong>
                  </span>

                  <span>{{ $t("summaryComponent.situation") }}</span>
                  <div>
                    <span v-if="paymentInfo.paymentStatus == 0 && paymentInfo.paymentType != 3" class="status pending">
                      <i class="fas fa-clock"></i>
                      {{ $t("summaryComponent.waiting-for-approval") }}
                    </span>

                    <span v-if="paymentInfo.paymentStatus == 0 && paymentInfo.paymentType == 3" class="status payment-awaiting">
                      <i class="fas fa-credit-card"></i>
                      {{ $t("summaryComponent.payment-pending") }}
                    </span>

                    <span v-if="paymentInfo.paymentStatus == 1" class="status confirmed">
                      <i class="fas fa-check-circle"></i>
                      {{ $t("summaryComponent.approved") }}
                    </span>

                    <span v-if="paymentInfo.paymentStatus == 2" class="status rejected">
                      <i class="fas fa-times-circle"></i>
                      {{ $t("summaryComponent.denied") }}
                    </span>
                  </div>
                </div>
                <!-- <div class="payment-information">
              <i class="fas fa-info-circle"></i>
              <span>{{ $t("summaryComponent.transaction-wait-msg") }}</span>
            </div> -->
              </div>
            </el-collapse-item>

            <el-collapse-item class="section" name="2">
              <div class="section-header" slot="title">
                <div class="title">
                  <div class="icon">
                    <i class="fas fa-user"></i>
                  </div>
                  <span>{{ $t("summaryComponent.transaction-information") }}</span>
                  <i class="fas fa-angle-down"></i>
                </div>
                <div class="actions"></div>
              </div>
              <div class="section-body proc-section">
                <div class="proc-wrapper">
                  <span>{{ $t("summaryComponent.performer-transaction-name") }}</span>
                  <span>
                    <b>{{ paymentInfo.customerName }}</b>
                  </span>

                  <span>{{ $t("summaryComponent.phone-number") }}</span>
                  <span>
                    <a :href="'tel:' + paymentInfo.customerPhoneNumber">{{ paymentInfo.customerPhoneNumber }}</a>
                  </span>

                  <span>{{ $t("summaryComponent.e-mail") }}</span>
                  <span>
                    <a :href="'mailto:' + paymentInfo.customerEmail">{{ paymentInfo.customerEmail }}</a>
                  </span>
                </div>
              </div>
            </el-collapse-item>

            <el-collapse-item class="section" name="3" v-if="paymentInfo.invoiceType == 1">
              <div class="section-header" slot="title">
                <div class="title">
                  <div class="icon">
                    <i class="fas fa-file-alt"></i>
                  </div>
                  <span>{{ $t("summaryComponent.invoice-receipt-info") }}</span>
                  <i class="fas fa-angle-down"></i>
                </div>
                <div class="actions"></div>
              </div>
              <div class="section-body invoice-section">
                <div class="invoice-wrapper">
                  <span>{{ $t("summaryComponent.type") }}</span>
                  <span>
                    <b>{{ $t("summaryComponent.individual") }}</b>
                  </span>

                  <span>{{ $t("summaryComponent.identity") }}</span>
                  <span>
                    <b>{{ paymentInfo.invoiceTitle3 }}</b>
                  </span>

                  <span>{{ $t("summaryComponent.address") }}</span>
                  <span>
                    <b>{{ paymentInfo.invoiceTitle4 }}</b>
                  </span>

                  <!-- <span>Şehir</span>
                  <span><b>İstanbul</b></span>

                  <span>Ülke</span>
                  <span><b>Türkiye</b></span> -->
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item class="section" name="3" v-if="paymentInfo.invoiceType == 2">
              <div class="section-header" slot="title">
                <div class="title">
                  <div class="icon">
                    <i class="fas fa-file-alt"></i>
                  </div>
                  <span>{{ $t("summaryComponent.invoice-receipt-info") }}</span>
                  <i class="fas fa-angle-down"></i>
                </div>
                <div class="actions"></div>
              </div>
              <div class="section-body invoice-section">
                <div class="invoice-wrapper">
                  <span>{{ $t("summaryComponent.type") }}</span>
                  <span>
                    <b>{{ $t("summaryComponent.institutional") }}</b>
                  </span>

                  <span>{{ $t("summaryComponent.official-title") }}</span>
                  <span>
                    <b>{{ paymentInfo.invoiceTitle1 }}</b>
                  </span>

                  <span>{{ $t("summaryComponent.tax-administration") }}</span>
                  <span>
                    <b>{{ paymentInfo.invoiceTitle2 }}</b>
                  </span>

                  <span>{{ $t("summaryComponent.tax-no") }}</span>
                  <span>
                    <b>{{ paymentInfo.invoiceTitle3 }}</b>
                  </span>

                  <span>{{ $t("summaryComponent.address") }}</span>
                  <span>
                    <b>{{ paymentInfo.invoiceTitle4 }}</b>
                  </span>

                  <!-- <span>Şehir</span>
                  <span><b>İstanbul</b></span>

                  <span>Ülke</span>
                  <span><b>Türkiye</b></span> -->
                </div>
              </div>
            </el-collapse-item>

            <el-collapse-item class="section" name="6">
              <div class="section-header" slot="title">
                <div class="title">
                  <div class="icon">
                    <i class="fas fa-shopping-basket"></i>
                  </div>
                  <span>{{ $t("summaryComponent.service") }}</span>
                  <i class="fas fa-angle-down"></i>
                </div>
                <div class="actions"></div>
              </div>
              <div class="section-body services-section">
                <div class="invoice-body">
                  <div class="summary-header">
                    <span>#</span>
                    <span>{{ $t("summaryComponent.product-service") }}</span>
                    <span>{{ $t("summaryComponent.unit-price") }}</span>
                    <span>{{ $t("summaryComponent.quantity") }}</span>
                    <span>{{ $t("summaryComponent.amount") }}</span>
                  </div>
                  <div class="summary-item" :index="index" v-for="(item, index) in services" :key="index">
                    <span>#{{ index + 1 }}</span>
                    <span>
                      <p>{{ item.serviceName }}</p>
                      {{ item.title }}
                    </span>
                    <span>{{ item.price > 0 ? $currency.format(item.price, { code: currency }) : $t("summaryComponent.free") }}</span>
                    <span>
                      <b>{{ item.count }}</b>
                    </span>
                    <span>
                      <b>{{ item.total > 0 ? $currency.format(item.total, { code: currency }) : $t("summaryComponent.free") }}</b>
                    </span>
                  </div>
                  <!-- <div class="summary-item" :index="index" v-for="(item, index) in registerUsers" :key="index">
                    <span>#{{ index + 1 }}</span>
                    <span>
                      <p>{{ item.serviceName }}</p>
                      {{ item.title }}
                    </span>
                    <span>{{ item.price > 0 ? $currency.format(item.price, { code: currency }) : $t("summaryComponent.free") }}</span>
                    <span>
                      <b>{{ item.count }}</b>
                    </span>
                    <span>
                      <b>{{ item.total > 0 ? $currency.format(item.total, { code: currency }) : $t("summaryComponent.free") }}</b>
                    </span>
                  </div> -->
                </div>

                <div class="invoice-summary">
                  <div class="calculate-item">
                    <span>{{ $t("summaryComponent.subtotal") }}</span>
                    <span>
                      <b>{{ $currency.format(paymentInfo.price, { code: currency }) }}</b>
                    </span>
                  </div>
                  <div class="calculate-item">
                    <span>{{ $t("summaryComponent.discounts") }}</span>
                    <span>
                      <template v-if="paymentInfo.discountPrice != 0">-</template>
                      <b>{{ $currency.format(paymentInfo.discountPrice, { code: currency }) }}</b>
                    </span>
                  </div>
                  <div class="calculate-item" v-if="registerForm.paymentInfo.taxName != null">
                    <span>
                      {{ $t("summaryComponent.taxes") }}
                      <b>({{ registerForm.paymentInfo.taxName }})</b>
                    </span>
                    <span>
                      <b>{{ $currency.format(paymentInfo.taxPrice, { code: currency }) }}</b>
                    </span>
                  </div>
                  <div class="calculate-item">
                    <span>{{ $t("summaryComponent.total") }}</span>
                    <span>
                      <b>{{ $currency.format(paymentInfo.paidPrice, { code: currency }) }}</b>
                    </span>
                  </div>
                </div>
              </div>
            </el-collapse-item>

            <el-collapse-item class="section" name="7" v-if="paymentInfo.paymentType == 3 && registerForm">
              <div class="section-header" slot="title">
                <div class="title">
                  <div class="icon">
                    <i class="fas fa-building"></i>
                  </div>
                  <span>{{ $t("summaryComponent.bank-information") }}</span>
                  <i class="fas fa-angle-down"></i>
                </div>
                <div class="actions"></div>
              </div>
              <div class="section-body bank-section" v-if="registerForm.paymentInfo.wiredPayments" v-html="registerForm.paymentInfo.wiredPaymentsInfo"></div>
              <el-alert v-else :show-icon="true" type="info" :title="$t('summaryComponent.bank-information-no-msg')"></el-alert>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-row>
    </transition>

    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && registerForm != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.files.fileAddUpdate.close") }}</el-button>
      </div>
      <div class="right-buttons"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SummaryComponent",
  components: {},
  props: ["participant", "paymentInfo"],
  data() {
    return {
      loading: false,
      timeout: null,
      registerForm: null,
      activeName: ["1", "2", "3", "4", "5", "6", "7"],
      registerUsers: []
    };
  },
  methods: {},
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timouet = setTimeout(async () => {
      var res = await this.$store.dispatch("getRegisterFormOne", this.participant.registrationFormId);
      this.registerForm = res.data.data.item;
      var res2 = await this.$store.dispatch("getPaymentIDDetail", this.paymentInfo.paymentID);
      this.registerUsers = res2.data.data.items.filter(x => x.id != this.participant.id);
      this.loading = false;
    }, 500);
  },
  computed: {
    services() {
      var result = [];

      if (this.participant != null && this.participant != undefined) {
        if (this.registerForm != null && this.registerForm != undefined) {
          var priceObjParticipant = {
            id: this.participant.id,
            serviceName: this.participant.packet != null ? "Registration " + this.participant.packet.title : "",
            title: this.participant.firstName + " " + this.participant.lastName,
            count: 1,
            price: this.paymentInfo.packetPrice ? this.paymentInfo.packetPrice : 0,
            total: this.paymentInfo.packetPrice ? this.paymentInfo.packetPrice : 0
          };
          this.participant.registrationInputs.forEach(x => {
            if (x.options != null && x.options != undefined) {
              if (x.answer != null && (x.type == 15 || x.type == 16) && !x.allowMultipleSelections) {
                var selectedOption = null;
                if (x.options.some(y => y.id == x.answer)) {
                  var selectedOption = x.options.find(y => y.id == x.answer);
                  if (selectedOption != null) {
                    priceObjParticipant.price += selectedOption.price;
                    priceObjParticipant.total += selectedOption.price;
                  }
                }
                console.log("selectedOption", selectedOption);
              }
              if (x.answers.length > 0 && ((x.type == 16 && x.allowMultipleSelections) || x.type == 100)) {
                var selectedOptions = x.options.filter(g => x.answers.some(c => c == g.id));
                // x.answers.forEach((y) => {
                //   if (x.options.some((g) => g.id == y)) {
                //     selectedOptions.push(x.options.find((g) => g.id == y));
                //   }
                // });
                var totalPrice = 0;
                selectedOptions.forEach(x => {
                  totalPrice += x.price;
                });
                console.log("selectedOption", selectedOptions);

                priceObjParticipant.price += totalPrice;
                priceObjParticipant.total += totalPrice;
              }
            }
          });

          result.push(priceObjParticipant);

          this.registerUsers.forEach(registerUser => {
            var priceObjParticipant = {
              id: registerUser.id,
              serviceName: registerUser.packet != null ? "Registration " + registerUser.packet.title : "",
              title: registerUser.firstName + " " + registerUser.lastName,
              count: 1,
              price: registerUser.paymentInfos[0].packetPrice ? registerUser.paymentInfos[0].packetPrice : 0,
              total: registerUser.paymentInfos[0].packetPrice ? registerUser.paymentInfos[0].packetPrice : 0
            };

            registerUser.registrationInputs.forEach(x => {
              if (x.options != null && x.options != undefined) {
                if (x.answer != null && (x.type == 15 || x.type == 16) && !x.allowMultipleSelections) {
                  var selectedOption = null;
                  if (x.options.some(y => y.id == x.answer)) {
                    var selectedOption = x.options.find(y => y.id == x.answer);
                    if (selectedOption != null) {
                      priceObjParticipant.price += selectedOption.price;
                      priceObjParticipant.total += selectedOption.price;
                    }
                  }
                  console.log("selectedOption", selectedOption);
                }
                if (x.answers.length > 0 && ((x.type == 16 && x.allowMultipleSelections) || x.type == 100)) {
                  var selectedOptions = x.options.filter(g => x.answers.some(c => c == g.id));
                  // x.answers.forEach((y) => {
                  //   if (x.options.some((g) => g.id == y)) {
                  //     selectedOptions.push(x.options.find((g) => g.id == y));
                  //   }
                  // });
                  var totalPrice = 0;
                  selectedOptions.forEach(x => {
                    totalPrice += x.price;
                  });
                  console.log("selectedOption", selectedOptions);

                  priceObjParticipant.price += totalPrice;
                  priceObjParticipant.total += totalPrice;
                }
              }
            });
            result.push(priceObjParticipant);
          });
          // ek hizmetliler
          if (this.participant.additionalServices.length > 0) {
            this.participant.additionalServices.forEach(x => {
              var fIndex = this.participant.additionalServices.findIndex(y => y.id == x.id);
              if (fIndex != -1) {
                var participantService = this.participant.additionalServices[fIndex];
                var service = this.registerForm.additionalServices.find(x => x.id == participantService.additionalServiceId);
                var priceObj = { id: service.id, title: service.title, serviceName: this.$t("summaryComponent.additional-service"), price: service.price, count: 1, total: service.price };
                x.questions.forEach(f => {
                  if (f.options != null && f.options != undefined) {
                    if (f.answer != null && (f.type == 15 || f.type == 16) && !f.allowMultipleSelections) {
                      var selectedOption = null;
                      if (f.options.some(y => y.id == f.answer)) {
                        var selectedOption = f.options.find(y => y.id == f.answer);
                        if (selectedOption != null) {
                          priceObj.price += selectedOption.price;
                          priceObj.total += selectedOption.price;
                        }
                      }
                      console.log("selectedOption", selectedOption);
                    }
                    if (f.answers.length > 0 && ((f.type == 16 && f.allowMultipleSelections) || f.type == 100)) {
                      var selectedOptions = f.options.filter(g => f.answers.some(c => c == g.id));
                      // f.answers.forEach((y) => {
                      //   if (f.options.some((g) => g.id == y)) {
                      //     selectedOptions.push(f.options.find((g) => g.id == y));
                      //   }
                      // });
                      var totalPrice = 0;
                      selectedOptions.forEach(f => {
                        totalPrice += f.price;
                      });
                      console.log("selectedOption", selectedOptions);

                      priceObj.price += totalPrice;
                      priceObj.total += totalPrice;
                    }
                  }
                });
                if (service != null) {
                  console.log("serve", service);
                  result.push(priceObj);
                }
              }
            });
          }

          // refakatçiler
          if (this.participant.accompayingPersons.length > 0) {
            this.participant.accompayingPersons.forEach(person => {
              var acc = person;
              var priceObj = {
                id: "accompayingPerson",
                serviceName: this.$t("summaryComponent.companions"),
                title: acc.questions.find(x => x.type == 1000).answer + " " + acc.questions.find(x => x.type == 10001).answer,
                count: 1,
                price: acc.price,
                total: acc.price
              };
              acc.questions.forEach(h => {
                if (h.options != null && h.options != undefined) {
                  if (h.answer != null && (h.type == 15 || h.type == 16) && !h.allowMultipleSelections) {
                    var selectedOption = null;
                    if (h.options.some(y => y.id == h.answer)) {
                      var selectedOption = h.options.find(y => y.id == h.answer);
                      if (selectedOption != null) {
                        priceObj.price += selectedOption.price;
                        priceObj.total += selectedOption.price;
                      }
                    }
                    console.log("selectedOption", selectedOption);
                  }
                  if (h.answers.length > 0 && ((h.type == 16 && h.allowMultipleSelections) || h.type == 100)) {
                    var selectedOptions = h.options.filter(g => h.answers.some(c => c == g.id));
                    // h.answers.forEach((y) => {
                    //   if (h.options.some((g) => g.id == y)) {
                    //     selectedOptions.push(h.options.find((g) => g.id == y));
                    //   }
                    // });
                    var totalPrice = 0;
                    selectedOptions.forEach(h => {
                      totalPrice += h.price;
                    });
                    console.log("selectedOption", selectedOptions);

                    priceObj.price += totalPrice;
                    priceObj.total += totalPrice;
                  }
                }
              });
              result.push(priceObj);
            });
          }
        }
      }

      return result;
    },
    currency() {
      return this.getEnumsDisplay("Currency", this.paymentInfo.currency);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/participants/SummaryComponent.vue